import type { GiftCardData } from "@app/interface/ProductGiftCard";
import * as React from "react";

interface GiftCardFormProps {
  giftCardData: GiftCardData;
  setGiftCardData: React.Dispatch<React.SetStateAction<GiftCardData>>;
}

const GiftCardForm = ({ giftCardData, setGiftCardData }: GiftCardFormProps) => {
  return (
    <div className="gift-card-form">
      <h2 className="swatches-group__title h6">Details:</h2>
      <div>
        <div className="form-group__row">
          {/* Recipient Name */}
          <div className="form-group">
            <label htmlFor="giftCardRecipientName" className="form-group__label">
              Recipient Name
            </label>
            <input
              required
              type="text"
              id="giftCardRecipientName"
              className="form-group__input"
              placeholder="Recipient name"
              value={giftCardData.recipientName}
              onChange={(e) => {
                const sanitized = e.target.value.replace(/[><&"]/g, '');
                setGiftCardData((prev) => ({
                  ...prev,
                  recipientName: sanitized,
                }));
              }}
            />
          </div>

          {/* Sender Name */}
          <div className="form-group">
            <label htmlFor="giftCardSenderName" className="form-group__label">
              Sender Name
            </label>
            <input
              required
              type="text"
              id="giftCardSenderName"
              className="form-group__input"
              placeholder="Sender name"
              value={giftCardData.senderName}
              onChange={(e) => {
                const sanitized = e.target.value.replace(/[><&"]/g, '');
                setGiftCardData((prev) => ({
                  ...prev,
                  senderName: sanitized,
                }));
              }}
            />
          </div>
        </div>

        {/* Recipient Email */}
        <div className="form-group">
          <label htmlFor="giftCardRecipientEmail" className="form-group__label">
            Recipient Email
          </label>
          <input
            required
            type="email"
            id="giftCardRecipientEmail"
            className="form-group__input"
            placeholder="Recipient Email"
            value={giftCardData.recipientEmail}
            onChange={(e) =>
              setGiftCardData((prev) => ({
                ...prev,
                recipientEmail: e.target.value,
              }))
            }
          />
        </div>

        {/* Your Message */}
        <div className="form-group">
          <label htmlFor="giftCardMessage" className="form-group__label">
            Your Message
          </label>
          <textarea
            id="giftCardMessage"
            className="form-group__input"
            placeholder="Your Message (optional)"
            value={giftCardData.message}
            onChange={(e) => {
              const sanitized = e.target.value.replace(/[><&"]/g, '');
              setGiftCardData((prev) => ({
                ...prev,
                message: sanitized,
              }));
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default GiftCardForm;
